module.exports = __webpack_public_path__ + "static/awolola-5cf89d9c463444fe8754a9e408abc895.png";